import firebase from 'firebase'

var firebaseConfig = {
    apiKey: "AIzaSyDlPNm1h_ItKsiAvritVxWA7KXzdXyiwtA",
    authDomain: "snowball-12b87.firebaseapp.com",
    projectId: "snowball-12b87",
    storageBucket: "snowball-12b87.appspot.com",
    messagingSenderId: "474489879631",
    appId: "1:474489879631:web:e7588f7c1ac908a6bd7e3a",
    measurementId: "G-BEXVDN2NVR"
}

const fire = firebase.initializeApp(firebaseConfig);

export default fire;